// useTicketAccess.ts
import { useState, useCallback } from "react";
import { Exercise } from "./../../../models/Exercise";
import { TicketAccess, setTicketAccessFromExercise } from "../../../models/TicketAccess";

export default function useTicketAccess() {
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);

  const getTicketAccess = useCallback((exercise: Exercise) => {
    const access = setTicketAccessFromExercise(exercise.objectId, exercise.name, exercise.startTime);
    setTicketAccess(access);
  }, []);

  return { ticketAccess, getTicketAccess };
}
